import ErrorResponse from './ErrorResponse';
import { logUsage } from 'owa-analytics';

export default function logErrorResponse(requestName: string, errorResponse: ErrorResponse) {
    logUsage(
        'CalendarUpdateServiceError',
        {
            requestName_1: requestName,
            status_2: errorResponse?.status,
            errorCode_3: errorResponse?.code,
            errorDescription: errorResponse?.message,
        },
        {
            isCore: true,
        }
    );
}
